// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__49n3a","title":"Select_title__PDOFt","label":"Select_label__qRnLe"};